import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import url from "../../../Component/server";
import { fontStyles } from "../../../Component/style/common_font";
import {
  CenterView,
  Icon,
  RowView,
  RowView2,
} from "../../../Component/style/common_style";
import nick_dup_check, {
  phone_dup_check,
} from "../../../Component/tool/duplicate_check";
import Layout_Admin from "../../../Component/UI/Layout_Admin";
import PagingControl from "../../../Component/UI/PagingControl";
import SearchAddrApi from "../../User/Sign/Modal/SearchAddrApi";
import api from "../../../Component/axios_Interceptor/api";

interface Userlist {
  userid: string;
  nickname: string;
  name: string;
  phone: string;
  addr_basic: string;
  addr_detail: string;
  addr_num: string;
  join_dt: string;
  user_level: string;
  is_banned: string;
}

const Userlist = () => {
  const Navigate = useNavigate();
  const { page } = useParams();
  const isUserlist = page === "user";

  const [search_key, setSearch_key] = useState("nickname");
  const [search_value, setSearch_value] = useState("");
  const setting_searchKey = (e: React.ChangeEvent<HTMLSelectElement>) =>
    setSearch_key(e.target.value);
  const setting_searchValue = (e: React.ChangeEvent<HTMLInputElement>) =>
    setSearch_value(e.target.value);

  const [cnt, setCnt] = useState(0);
  const [userlist, setUserlist] = useState<Userlist[]>([]);
  const [currentPage, setCurrentPage] = useState(1);

  const go_userlist = () => {
    setCurrentPage(1);
    Navigate("/admin/userlist/user");
  };
  const go_blocklist = () => {
    setCurrentPage(1);
    Navigate("/admin/userlist/block");
  };

  const get_user_list = async () => {
    try {
      const res = await api.get(
        isUserlist
          ? url.Communication_url.follow_user_list
          : url.Communication_url.ban_user_list,
        {
          params: {
            current_page: currentPage,
            per_page: 20,
            search_key: search_key,
            search_value: search_value,
          },
        }
      );
      setUserlist(res.data.userList || []);
      setCnt(res.data.total || 0);
    } catch (error) {
      console.error("데이터 로드 실패:", error);
    }
  };
  useEffect(() => {
    get_user_list();
  }, [isUserlist, currentPage]);

  const openSearchAddr = async (origindata: Userlist) => {
    const { addr_num, addr_basic } = await SearchAddrApi({});
    setTimeout(async () => {
      window.focus();
      await modiUserAddr(origindata, addr_num, addr_basic);
    }, 100);
  };
  const modiUserAddr = async (
    origindata: Userlist,
    addr_num: string,
    addr_basic: string
  ) => {
    const modidata = window.prompt("상세주소를 적어주세요.");
    if (!modidata) {
      return;
    }

    const update_data: Userlist = {
      ...origindata,
      addr_num: addr_num,
      addr_basic: addr_basic,
      addr_detail: modidata,
    };
    const send_data = {
      userid: update_data.userid,
      addr_num: addr_num,
      addr_basic: addr_basic,
      addr_detail: modidata,
    };
    modify_user_info_API(update_data, send_data);
  };
  const modiUserinfo = async (origindata: Userlist, key: string) => {
    const guidtext =
      key === "nickname"
        ? "닉네임은 한글,숫자 2~8자로 입력해주세요.(영문,특수문자,공백 사용 불가능)"
        : key === "phone"
        ? "연락처 수정 ('-'기호를 넣어서 입력해주세요.)"
        : "입금자명 수정";

    const modidata = window.prompt(guidtext);
    if (!modidata) {
      return;
    }
    // 중복체크
    if (key === "nickname") {
      const isCheck = await nick_dup_check(modidata);
      if (isCheck === "err") {
        return;
      }
      if (!isCheck) {
        alert("이미 존재하는 닉네임 입니다.");
        return;
      }
    }
    if (key === "phone") {
      const isCheck = await phone_dup_check(modidata);
      if (isCheck === "err") {
        return;
      }
      if (!isCheck) {
        alert("이미 존재하는 번호 입니다.");
        return;
      }
    }
    const update_data: Userlist = { ...origindata, [key]: modidata };
    const send_data = {
      userid: update_data.userid,
      [key]: modidata,
    };
    modify_user_info_API(update_data, send_data);
  };
  const modify_user_info_API = async (
    update_data: Userlist,
    send_data: any
  ) => {
    // try {
    //   const res = await api.patch(
    //     url.Communication_url.modify_user_info,
    //     send_data
    //   );
    //   if (res.data === "성공") {
    //     setUserlist((newlist) =>
    //       newlist.map((user) =>
    //         user.userid === update_data.userid ? update_data : user
    //       )
    //     );
    //     alert("수정되었습니다.");
    //   }
    // } catch (error) {
    //   console.error("데이터 로드 실패:", error);
    // }
  };
  const userBan = async (
    nickname: string,
    userid: string,
    is_banned: string
  ) => {
    const guidtext = isUserlist && is_banned === "n" ? "차단" : "차단해제";
    const isSure = window.confirm(`${nickname} 님을 ${guidtext}하시겠습니까?`);

    if (!isSure) {
      return;
    }

    try {
      const res = await api.post(url.Communication_url.user_ban, {
        nickname: nickname,
      });
      if (res.data === "성공") {
        alert("정상적으로 처리되었습니다.");
        // if (isUserlist) {
        //   go_blocklist();
        // } else {
        //   go_userlist();
        // }
        get_user_list();
      }
    } catch (error) {
      console.error("데이터 로드 실패:", error);
    }
  };

  const userUnBan = async (
    nickname: string,
    userid: string,
    is_banned: string
  ) => {
    const guidtext = isUserlist && is_banned === "n" ? "차단" : "차단해제";
    const isSure = window.confirm(`${nickname} 님을 ${guidtext}하시겠습니까?`);

    if (!isSure) {
      return;
    }

    try {
      const res = await api.delete(url.Communication_url.user_unban, {
        data: { nickname: nickname },
      });
      if (res.data === "성공") {
        alert("정상적으로 처리되었습니다.");
        // if (isUserlist) {
        //   go_blocklist();
        // } else {
        //   go_userlist();
        // }
        get_user_list();
      }
    } catch (error) {
      console.error("데이터 로드 실패:", error);
    }
  };

  const search = () => {
    if (search_value.trim() === "") return;
    get_user_list();
  };
  const reset = () => window.location.reload();
  const keyPress_keyword = (e: React.KeyboardEvent<HTMLInputElement>) => {
    enterPress(e);
  };
  const enterPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (search_value.trim() === "") return;
    if (e.key === "Enter") {
      get_user_list();
    }
  };

  return (
    <Layout_Admin menuname={"회원목록"}>
      <Menu>
        <CenterView
          className={isUserlist ? "pagename" : "pagename gray"}
          onClick={go_userlist}
        >
          <div>회원목록</div>
          {isUserlist && <span className="bar" />}
        </CenterView>
        <CenterView
          className={!isUserlist ? "pagename" : "pagename gray"}
          onClick={go_blocklist}
        >
          <div>블랙리스트</div>
          {!isUserlist && <span className="bar" />}
        </CenterView>
      </Menu>

      <SearchArea>
        <select value={search_key} onChange={setting_searchKey}>
          <option value="nickname">닉네임</option>
          <option value="name">입금자명</option>
          <option value="phone">전화번호</option>
        </select>
        <input
          placeholder="찾으시는 회원을 입력해주세요."
          value={search_value}
          onChange={setting_searchValue}
          onKeyPress={keyPress_keyword}
        />
        <CenterView onClick={search}>검색</CenterView>
        <Icon
          src={require("../../../Image/ic_reset_black.png")}
          onClick={reset}
        />
      </SearchArea>

      <Table className="header">
        <span>번호</span>
        <Row>닉네임</Row>
        <Row>입금자명</Row>
        <Row className="flex2">연락처</Row>
        <Row className="flex4">주소</Row>
        <Row className="flex2">가입일자</Row>
        <Row style={{ maxWidth: "5rem" }}>차단</Row>
      </Table>

      {userlist.length === 0 ? (
        <Nonedata>회원이 없습니다.</Nonedata>
      ) : (
        userlist.map((data, idx) => {
          const boradnum = 20 * (currentPage - 1) + (idx + 1);
          return (
            <Table key={idx} className={isUserlist ? "" : "imgnone"}>
              <span>{boradnum}</span>
              <Row>
                <div>{data.nickname}</div>
              </Row>
              <Row>
                <div>{data.name}</div>
              </Row>
              <Row className="flex2">
                <div>{data.phone}</div>
              </Row>
              <Row className="flex4">
                <div>{`${data.addr_basic} ${data.addr_detail}`}</div>
              </Row>
              <Row className="flex2">
                <div>{data.join_dt}</div>
              </Row>
              <Btn
                className={isUserlist && data.is_banned === "n" ? "" : "light"}
                onClick={() =>
                  isUserlist && data.is_banned === "n"
                    ? userBan(data.nickname, data.userid, data.is_banned)
                    : userUnBan(data.nickname, data.userid, data.is_banned)
                }
              >
                차단
                {isUserlist && data.is_banned === "n" ? "하기" : "풀기"}
              </Btn>
            </Table>
          );
        })
      )}

      <PagingControl
        cnt={cnt}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </Layout_Admin>
  );
};

export default Userlist;

const Menu = styled(RowView2)`
  margin-bottom: 1rem;
  div.pagename {
    position: relative;
    width: 6rem;
    margin-right: 1rem;
    padding-bottom: 1rem;
    font-size: 20px;
    ${fontStyles.medium}
    cursor: pointer;
  }
  div.gray {
    color: #8e8e8e;
  }
  span.bar {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: #2d2d2d;
  }
`;
const SearchArea = styled(RowView2)`
  height: 3rem;
  margin-bottom: 1.5rem;
  select {
    padding: 0.8rem;
    margin-right: 0.5rem;
    font-size: 16px;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    outline: 0;
    cursor: pointer;
    &:hover,
    &:focus {
      border: 1px solid #454545;
    }
  }
  input {
    box-sizing: border-box;
    flex: 1;
    height: 100%;
    padding: 1rem;
    font-size: 16px;
    outline: 0;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    &::placeholder {
      color: #c6c6c6;
    }
    &:hover,
    &:focus {
      border: 1px solid #454545;
    }
  }
  div {
    width: 5rem;
    height: 100%;
    margin: 0rem 0.5rem;
    text-align: center;
    ${fontStyles.semiBold}
    color: white;
    background-color: #2d2d2d;
    border-radius: 8px;
    cursor: pointer;
  }
  img {
    padding: 0.5rem;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    cursor: pointer;
  }
`;
const Table = styled(RowView)`
  min-height: 4rem;
  border-bottom: 2px solid #f8f8f8;
  overflow: hidden;
  &.header {
    min-height: 3rem;
    ${fontStyles.medium}
    background-color: #f8f8f8;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &.imgnone {
    img {
      display: none;
    }
  }
  span {
    width: 4rem;
    text-align: center;
  }
`;
const Row = styled(CenterView)`
  flex: 1;
  margin: 0px 0.5rem;
  max-height: 2.4rem;
  text-align: center;
  div {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &.flex4 {
    flex: 4;
  }
  &.flex2 {
    flex: 2;
  }
  img {
    margin-left: 3px;
    cursor: pointer;
  }
`;
const Btn = styled.div`
  width: 5rem;
  min-width: 5rem;
  padding: 0.5rem 0rem;
  margin: 0rem 0.5rem;
  text-align: center;
  ${fontStyles.medium}
  font-size: 14px;
  color: white;
  background-color: #2d2d2d;
  border-radius: 4px;
  cursor: pointer;
  &.light {
    color: #2d2d2d;
    background-color: white;
    border: 1px solid #2d2d2d;
  }
`;
const Nonedata = styled(CenterView)`
  height: 10rem;
  color: #858585;
`;
